define('fukit/view/base.detail.page.view',['require','exports','module','./base.page.view','backbone.radio','./common/page.header.view','../behavior/confirm.model.destroy.on.press.behavior','../behavior/show.modal.on.navigate.with.unsaved.changes.behavior','../helpers/factory'],function(require, exports, module) {
  //prettier-ignore
  var BasePageView                                  = require('./base.page.view'),
      Radio                                         = require('backbone.radio'),
      PageHeaderView                                = require('./common/page.header.view'),
      ConfirmModelDestroyOnPressBehavior            = require('../behavior/confirm.model.destroy.on.press.behavior'),
      ShowModalOnNavigateWithUnsavedChangesBehavior = require('../behavior/show.modal.on.navigate.with.unsaved.changes.behavior'),
      Factory                                       = require('../helpers/factory');

  var BaseDetailPageView = BasePageView.extend({
    behaviors: {
      ShowModalOnNavigateWithUnsavedChanges: {
        behaviorClass: ShowModalOnNavigateWithUnsavedChangesBehavior,
      },
    },

    internalViewOptions: {
      pageHeaderView: function() {
        return {
          type: PageHeaderView,
          actions: [
            Factory.deleteButton({
              model: this.model,
              routeOnDestroyOptions: this.getOption('routeOnDestroyOptions'),
              destroyViewOptions: this.getOption('modalOptions'),
              enableOnlyWhen: this.getOption('actionDeleteButtonEnableOnlyWhen'),
              visibleOnlyWhen: this.getOption('actionDeleteButtonVisibleOnlyWhen'),
              setTextWhen: this.getOption('actionDeleteButtonSetTextWhen'),
            }),
            Factory.saveButton({
              model: this.model,
              enableOnlyWhen: this.getOption('actionSaveButtonEnableOnlyWhen'),
              visibleOnlyWhen: this.getOption('actionSaveButtonVisibleOnlyWhen'),
              setTextWhen: this.getOption('actionSaveButtonSetTextWhen'),
            }),
          ],
        };
      },
    },

    initialize: function() {
      BasePageView.prototype.initialize.apply(this, arguments);

      this.once('before:render', function() {
        var state = Radio.channel('AppKit.controllerService').request('state');
        if (state && this.model && this.model.isNew()) {
          state.set('editing', true);
        }
      });

      this.listenTo(this.model, 'sync', function() {
        var state = Radio.channel('AppKit.controllerService').request('state');
        if (state) {
          state.set('editing', false);
        }

        Radio.channel('validations.summaryView').trigger('setVisibility', false);
      });
    },
  });

  module.exports = BaseDetailPageView;
});

